import { FC, Suspense, useMemo } from 'react';
import { useNavigate } from 'react-router';
import {
  Typography,
  Stack,
  Card,
  CardContent,
  CardActionArea,
} from '@mui/material';

import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { useEnrollments } from '../hooks/useEnrollments';


const EnrollmentsList: FC = () => {
  const { enrollments } = useEnrollments();
  const navigate = useNavigate();

  const activeEnrollments = useMemo(() => {
    return enrollments.filter(enrollment => !enrollment.completedAt);
  }, [enrollments]);

  if (activeEnrollments.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ py: 8 }}>
        No active programs yet.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {activeEnrollments.map(enrollment => (
        <Card key={enrollment.id} variant="outlined">
          <CardActionArea onClick={() => navigate(`/programs/journey/${enrollment.id}`)}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {enrollment.program.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {enrollment.program.description}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Stack>
  );
};

export const ViewEnrollments: FC = () => {
  return (
    <Stack spacing={2}>
      <Typography variant="h4" fontSize={24}>
        My Programs
      </Typography>
      <ErrorBoundary>
        <Suspense fallback={<BodyLoading height="40vh"/>}>
          <EnrollmentsList/>
        </Suspense>
      </ErrorBoundary>
    </Stack>
  );
};
